import { metadata } from "./metadata.js";
// This will just load the actual admin menu component
import component from "@/blocks/dynamic/admin-menu/index.vue";

export default { metadata, component };
